import React from 'react'
import { SystemOutlineWarning } from '@dasa-health/icons'
import { Container, Title, Text, TextBold } from './styles'
import { WARNING_SERVICE_IS_DOWN } from 'redesign/constants'

export function WarningServiceIsDown() {
    return (
        <Container data-testid="warning-service-is-down-component">
            <Title>
                <SystemOutlineWarning fontSize="1.5rem" />
                {WARNING_SERVICE_IS_DOWN.title}
            </Title>
            <Text>{WARNING_SERVICE_IS_DOWN.message}</Text>
            <TextBold>{WARNING_SERVICE_IS_DOWN.featureMessage}</TextBold>
        </Container>
    )
}
